import React from "react";
import Footer from "../Templete/Footer";
import Header from "../Templete/Header";
import SignupBanner from "../Home/SignupBanner";

const InsurancePosp = () => {
  // Set page title and meta description
  React.useEffect(() => {
    document.title =
      "Insurance POSP Services API | FORMAX PAY - Insurance Point of Sales Person Solutions";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      const newMeta = document.createElement("meta");
      newMeta.name = "description";
      newMeta.content =
        "IRDAI-approved Insurance POSP services. Partner with licensed insurers through FORMAX PAY APIs for car, bike, health insurance. Instant policy issuance, real-time payouts, SSO integration for fintech platforms.";
      document.head.appendChild(newMeta);
    }
  }, []);

  return (
    <>
      <Header />

      {/* SEO: Structured Data Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FinancialService",
          name: "Insurance POSP Services API",
          description:
            "IRDAI-approved Insurance Point of Sales Person services with API integration for fintech platforms. Instant policy issuance and real-time payouts.",
          provider: {
            "@type": "Organization",
            name: "Formax IT Solutions Private Limited",
            legalName: "Formax IT Solutions Private Limited",
            url: "https://formaxpay.com",
          },
          serviceType: [
            "Insurance API",
            "POSP Services",
            "Insurance Distribution",
          ],
          areaServed: "India",
          offers: {
            "@type": "Offer",
            category: "Insurance Services",
          },
        })}
      </script>

      {/* Hero Section */}
      <section className="bg-half-170 bg-light d-table w-100">
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-lg-10 text-center">
              <div className="pages-heading">
                <h1 className="title mb-4" style={{ fontSize: "2.5rem" }}>
                  Insurance POSP Services
                </h1>
                <p className="text-muted para-desc mx-auto mb-0 fs-5">
                  IRDAI-approved Insurance Point of Sales Person services.
                  Partner with licensed insurers through our robust APIs and
                  offer comprehensive insurance solutions on your platform.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shape Divider */}
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      {/* Insurance Services Section */}
      <section className="section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div className="position-relative">
                <img
                  src="/images/insurance-api-banner.png"
                  className="rounded img-fluid mx-auto d-block"
                  alt="Insurance POSP Services"
                />
              </div>
            </div>

            <div className="col-lg-7 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div className="section-title ms-lg-4">
                <h4 className="title mb-4">Partner with Licensed Insurers</h4>
                <p className="text-muted">
                  FORMAX PAY has partnered with IRDAI-licensed insurers to
                  provide comprehensive
                  <span className="text-primary fw-bold">
                    {" "}
                    Insurance POSP (Point of Sales Person)
                  </span>{" "}
                  services. Our API solutions enable fintech platforms to
                  seamlessly integrate insurance services and offer them
                  directly to their users.
                </p>
                <div className="row mt-4">
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Car Insurance
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Bike Insurance
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Health Insurance
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Life Insurance
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Travel Insurance
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Commercial Insurance
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="section bg-light" id="features">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-4 pb-2">
                <h4 className="title mb-4">
                  Why Choose Our Insurance POSP Services
                </h4>
                <p className="text-muted para-desc mx-auto mb-0">
                  Comprehensive API solutions designed specifically for fintech
                  platforms
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-bolt-alt fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Instant Policy Issuance</h5>
                  <p className="text-muted mb-0">
                    Real-time policy generation and issuance through automated
                    API integration.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-transaction fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Instant Payouts</h5>
                  <p className="text-muted mb-0">
                    Real-time commission settlements directly to your wallet or
                    bank account.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-shield-check fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">SSO Auto Login</h5>
                  <p className="text-muted mb-0">
                    Single Sign-On integration for seamless user experience
                    across platforms.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-code-branch fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Robust API Integration</h5>
                  <p className="text-muted mb-0">
                    Easy-to-integrate REST APIs with comprehensive
                    documentation.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-analytics fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Complete MIS Reports</h5>
                  <p className="text-muted mb-0">
                    Detailed analytics and reporting dashboard for all
                    transactions.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-lock fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">IRDAI Compliant</h5>
                  <p className="text-muted mb-0">
                    Fully compliant with all IRDAI regulations and guidelines.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-5">
                <h4 className="title mb-4">Simple Integration Process</h4>
                <p className="text-muted para-desc mx-auto">
                  Get started with insurance services in 4 easy steps
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-6 mt-4 pt-2">
              <div className="card border-0 text-center features feature-primary">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-user-plus fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">1. Register</h5>
                  <p className="text-muted mb-0">
                    Sign up as a API partner & complete documentation process
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mt-4 pt-2">
              <div className="card border-0 text-center features feature-primary">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-key-skeleton fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">2. Get API Keys</h5>
                  <p className="text-muted mb-0">
                    Generate API credentials from dashbaord, whitelist IP and
                    update webhook URLs
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mt-4 pt-2">
              <div className="card border-0 text-center features feature-primary">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-arrow fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">3. Integrate</h5>
                  <p className="text-muted mb-0">
                    Implement APIs into your platform
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mt-4 pt-2">
              <div className="card border-0 text-center features feature-primary">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-rocket fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">4. Go Live</h5>
                  <p className="text-muted mb-0">
                    Start offering insurance services
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Wallet Integration Section */}
      <section className="section bg-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="section-title">
                <h4 className="title mb-4">Seamless Wallet Integration</h4>
                <p className="text-muted">
                  Integrate insurance services directly with your wallet system.
                  Users can purchase insurance policies using their existing
                  wallet balance.
                </p>
                <ul className="list-unstyled text-muted">
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Direct wallet-to-wallet settlements
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Real-time balance updates
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Automated commission calculations
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Instant refund processing
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/insurance-wallet-integration.png"
                className="img-fluid rounded shadow"
                alt="Wallet Integration"
              />
            </div>
          </div>
        </div>
      </section>

      <SignupBanner />

      <Footer />
    </>
  );
};

export default InsurancePosp;
